import React from 'react';

import classNames from 'classnames';
import CloseIcon from 'icons/ic-close.svg';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import useELearningCourse from 'components/hooks/useELearningCourse';

import Tooltip from 'components/application/Tooltip';

import { formatDuration } from 'components/helpers/dates';

export default function NonCustomELearningCourseCard({
  disabledTooltip,
  eLearningCourseId,
  isDisabled = false,
  onClose,
  onError,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'courses.NonCustomELearningCourseCard',
  });

  const { t: i18nTCourses } = useTranslation('common', {
    keyPrefix: 'courses',
  });

  const eLearningCourse = useELearningCourse(eLearningCourseId, onError);

  const { detailsUrl, durationParts, name } = eLearningCourse?.attributes || {};

  return (
    <div className={classNames(isDisabled && 'tooltip-parent')}>
      <div
        className={classNames(
          'tw-relative tw-rounded-md tw-border-1 tw-border-solid tw-border-grey-100 tw-bg-white tw-py-2 tw-pl-3 tw-pr-10',
          !eLearningCourse && 'tw-h-22.5',
          isDisabled ? 'tw-bg-grey-025' : 'tw-bg-white',
        )}
      >
        {eLearningCourse && (
          <>
            <div className='tw-mb-1'>{name}</div>
            <div className='tw-mb-1 tw-text-s tw-tracking-wide'>
              {i18nTCourses('durationAnd1CreditPerCourse', {
                duration: formatDuration({ durationParts }),
              })}
            </div>
            <div className='tw-flex'>
              <a
                className='app-link tw-text-s tw-tracking-wide tw-text-blue-500 hover:tw-text-blue-300 active:tw-text-blue-300'
                href={detailsUrl}
                target='blank'
              >
                {i18nT('learnMore')}
              </a>
            </div>
            <CloseIcon
              className={classNames(
                'handshq--hoverable tw-absolute tw-right-2 tw-top-2',
                isDisabled ?
                  '[&_polygon]:tw-fill-grey-300'
                : '[&_polygon]:tw-fill-grey-500',
              )}
              height={24}
              onClick={isDisabled ? () => undefined : onClose}
              width={24}
            />
          </>
        )}
      </div>
      {disabledTooltip && (
        <Tooltip placement='top' tooltip={disabledTooltip} trigger='hover' />
      )}
    </div>
  );
}

NonCustomELearningCourseCard.propTypes = {
  disabledTooltip: PropTypes.string,
  eLearningCourseId: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
};
